import { render, staticRenderFns } from "./SimilarityNewsListItem.vue?vue&type=template&id=5c8d8af9&scoped=true"
import script from "./SimilarityNewsListItem.vue?vue&type=script&lang=js"
export * from "./SimilarityNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./SimilarityNewsListItem.vue?vue&type=style&index=0&id=5c8d8af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d8af9",
  null
  
)

export default component.exports